export default __webpack_public_path__ + "static/media/655-tile.f9ac888f.svg";